import {
  Card,
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { CheckCircleOutline, HighlightOff } from "@material-ui/icons";
import React, { useState } from "react";
import Avatar from "react-avatar";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { startLoading, stopLoading } from "../../../../actions/loadingAction";
import {
  errorSnackbar,
  successSnackbar,
} from "../../../../actions/snackbarActions";
import { Endpoint, Status } from "../../../../apis/apiConstants";
import AjaxHelper from "../../../../apis/apiRequest";

export default function FamilyComponent(props) {
  const [approvals, setApprovals] = useState([]);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (props.approvalType === "Family") {
      getAllApprovals(1, "");
    }
  }, [props.approvalType]);

  const getAllApprovals = (page, search) => {
    dispatch(startLoading);
    AjaxHelper.getApi(navigate, Endpoint.GET_APPROVAL, {}, { page, search })
      .then((response) => {
        console.log(response, "approvals response");
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          setApprovals(response.data.data);
        } else if (response.data.status === Status.API_NO_CONTENT) {
          setApprovals([]);
          dispatch(errorSnackbar(response.data.message));
        } else {
          dispatch(errorSnackbar(response.data.message));
        }
      })
      .catch((error) => {
        dispatch(errorSnackbar("Error while fetching family approvals."));
      });
  };

  const approveRelation = (id, relationshipType, status) => {
    const params = {
      _id: id,
      status: status,
      relationshipType: relationshipType,
    };
    AjaxHelper.postApi(navigate, Endpoint.UPDATE_RELATION, params)
      .then((response) => {
        console.log(params, "logging params");
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          dispatch(successSnackbar("Status updated."));
          getAllApprovals(1, "");
        } else {
          dispatch(errorSnackbar("Error while updating the approval."));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while updating the approval."));
      });
  };

  return (
    <Card className="innerCard mt-3" variant="outlined">
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow className={"background-color-head"}>
              <TableCell>
                <span className={"font-bold font-18"}>Name</span>
              </TableCell>
              <TableCell>
                <span className={"font-bold font-18"}>Contact</span>
              </TableCell>
              <TableCell>
                <span className={"font-bold font-18"}>Relationship Type</span>
              </TableCell>
              <TableCell align="center">
                <span className={"font-bold font-18"}>Status</span>
              </TableCell>
              <TableCell align="center">
                <span className={"font-bold font-18"}>Actions</span>
              </TableCell>
            </TableRow>
          </TableHead>

          {approvals.map((approval) => (
            <TableRow key={approval.id}>
              <TableCell>
                <div className="approvalDisplay">
                  <Avatar
                    name={`${approval.from.firstName} ${approval.from.lastName}`}
                    round={true}
                    size="40"
                    textSizeRatio={3}
                  />
                  <div>
                    <div className="proName">{`${approval.from.firstName} ${approval.from.lastName}`}</div>
                    <div className="appFont">{`${approval.from.userCode}`}</div>
                  </div>
                </div>
              </TableCell>
              <TableCell>
                <div className="appFont">{`${approval.from.city} ${approval.from.state} ${approval.from.country} `}</div>
                <div className="appFont">{`${approval.from.email} `}</div>
                <div className="appFont">{`${approval.from.mobile} `}</div>
              </TableCell>

              <TableCell>{approval.relationshipType}</TableCell>
              <TableCell>{approval.status}</TableCell>
              <TableCell align="center">
                <IconButton
                  style={{ color: "green" }}
                  onClick={() =>
                    approveRelation(
                      approval._id,
                      approval.relationshipType,
                      "approved"
                    )
                  }
                >
                  <CheckCircleOutline />
                </IconButton>
                <IconButton
                  style={{ color: "red" }}
                  onClick={() =>
                    approveRelation(
                      approval._id,
                      approval.relationshipType,
                      "rejected"
                    )
                  }
                >
                  <HighlightOff />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </Table>
      </TableContainer>
    </Card>
  );
}
